import React from 'react'
import BudgetActionRow from './BudgetActionRow'
import withView from '../../../cmn/docAutomation/withView';
import FormButton from '../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import SarasInput from '../../../../library/input/textField/SarasInput'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";

const BudgetActionOS = (props) => {
    const { formObject, viewData } = props;
    const [joId, setJOId] = React.useState();

    const onJoIdChange = (e, joId) => {
        setJOId(joId);
    }

    const renderRows = () => {
        return (
            Object.values(viewData).map((row, index) => (
                <li className="uiSearchRow"><BudgetActionRow formObject={formObject} rowKey={row.rowKey} viewData={row} /></li>
            ))
        )
    }

    if (!viewData)
        return (null)

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value="Linked Job Orders" /></span>
                    </UiTitle>
                    <UiAction>
                        <SarasInput onChange={onJoIdChange} type='text' value={joId} placeholder='Job order Id' /> 
                        <FormButton formObject={formObject} ksc="l" rowKey="" headerKey="budgetAction" className="uiActionButton"
                            action={{ actionId: "refresh", actionName: "budgetComp", refreshMode:"self",
                            actionParam: { actionType: "linkJO", tdtId: 1501, tdId: joId, dIds:"#docId"} }}
                            text={<SarasTrans value="Link Job Order" />}></FormButton>
                        <FormButton formObject={formObject} ksc="c" rowKey="" headerKey="budgetAction" className="uiActionButton"
                            action={{ actionId: "new", actionName: "prodComp", containerKey: "popup",
                            actionParam: { actionType: "CreateProdFromBudget", tdtId: 1501, dIds:"#docId" } }}
                            text={<SarasTrans value="Create Job Order" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Order ID" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Quantity" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            renderRows()
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(BudgetActionOS, "budgetAction", "budgetAction,budgetHeader");